import apiClient from './client';

// Allineato al modello documenti post-V25 (Blocco 5 Parte B STEP 2):
// `tipo` semantico in {preventivo, scheda_omologa, omologa_produttore} +
// `origine` esplicita in {generato, firmato}. La distinzione non si inferisce
// più dal suffisso del tipo.
export type DocumentoTipo = 'preventivo' | 'scheda_omologa' | 'omologa_produttore' | string;
export type DocumentoOrigine = 'generato' | 'firmato';

export interface DocumentoItem {
  id: string;
  order_id: string;
  tipo: DocumentoTipo;
  origine: DocumentoOrigine;
  url_storage: string;
  generato_at: string;
  inviato_at: string | null;
  url_download: string;
  /**
   * V68 — documento SUPERATO da una riapertura. Non e' cancellato: resta
   * visibile e scaricabile. Il preventivo firmato e' traccia legale (#75).
   */
  deprecato_at?: string | null;
  deprecato_da?: string | null;
}

export async function listDocumentiOrdine(ordineId: string): Promise<DocumentoItem[]> {
  const { data } = await apiClient.get<DocumentoItem[]>(`/api/richieste/${ordineId}/documenti`);
  return data;
}

export function getDownloadUrl(documentId: string): string {
  return `/api/documents/${documentId}/download`;
}

// NOTA: upload-preventivo-firmato / upload-omologa-firmata sono stati rimossi
// in backend (#75): l'upload del firmato avviene dentro le transizioni
// `conferma` (preventivo) e `in-progress` (omologa produttore) — vedi
// `confermaRichiesta`/`passaInProgress` in `api/richieste.ts`.
